// "city" field input validity pattern
// accepts zero-or-more; any "required" validity is a separate constraint
export const userCityValidityPattern = /^[^0-9]*$/i // "anything except numbers"
